import {ChangeDetectionStrategy, Component} from '@angular/core';

import {Modal} from '@softline/ui-core';
import {Checkliste} from '../../types/checkliste';

@Component({
    selector: 'soft-select-checkliste-dialog',
    imports: [],
    templateUrl: './select-checkliste-dialog.component.html',
    styleUrl: './select-checkliste-dialog.component.css',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SelectChecklisteDialogComponent implements Modal<Checkliste | null> {

  close!: (result: (Checkliste | null)) => void;

  registerCloseHandler(handler: (result: (Checkliste | null)) => void) {
    this.close = handler;
  }
}
